import { IntegrationType } from 'generated/generated-graphql'

export const IntegrationImages: Record<IntegrationType, string> = {
  [IntegrationType.ParamountLiquor]: '/integrations/paramount-liquor.svg',
  [IntegrationType.VenusAndBooker]: '/integrations/venus-and-booker.svg',
}
